<template>
  <div>
    <div id="app">
      <router-view/>
    </div><!-- app_layer -->
    <div id="popup_layer"></div><!-- popup_layer -->
    <div id="comp_layer"></div><!-- comp_layer -->
    <loading :visible="showLoading" @close="closeLoading"></loading><!-- load_layer -->
    <div id="alert_layer"></div><!-- alert_layer -->
  </div>
</template>

<script>
// if (typeof Object.assign != 'function') {
//   // Must be writable: true, enumerable: false, configurable: true
//   Object.defineProperty(Object, "assign", {
//     value: function assign(target, varArgs) { // .length of function is 2
//       'use strict';
//       if (target == null) { // TypeError if undefined or null
//         throw new TypeError('Cannot convert undefined or null to object');
//       }
//
//       var to = Object(target);
//
//       for (var index = 1; index < arguments.length; index++) {
//         var nextSource = arguments[index];
//
//         if (nextSource != null) { // Skip over if undefined or null
//           for (var nextKey in nextSource) {
//             // Avoid bugs when hasOwnProperty is shadowed
//             if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
//               to[nextKey] = nextSource[nextKey];
//             }
//           }
//         }
//       }
//       return to;
//     },
//     writable: true,
//     configurable: true
//   });
// }
import Loading from '@/views/components/Loading';
export default {
  components: {
    Loading,
  },
  computed: {
    showLoading () { return this.$store.getters['loading/show_loading']; },
  },
  methods: {
    closeLoading () {
      this.$store.commit('loading/set_loading', false);
    },
  },
};
</script>

<style lang="scss">
  @import "@/css/app.scss";
</style>
